module.exports = "/images/cookie_policy_icon.svg?1b5e10806b29a18f16ac39af4f12191f";